import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import {
  fontSize,
  fontWeight,
  radius,
  space,
} from '@elementary/common-ui/style/utils';

const EMPTY_STATE_PADDING = '80px';
const EMPTY_STATE_SHADOW_OFFSET = '0px 16px 250px 0px';

const Wrapper = styled(FlexColumn)`
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  box-shadow: ${({ theme }) =>
    `${EMPTY_STATE_SHADOW_OFFSET} ${theme.palette.shadow.inkSubtle}`};
  backdrop-filter: blur(8px);
  border-radius: ${radius('xxl')};
  padding: ${EMPTY_STATE_PADDING};
  gap: ${space('lg')};
`;

type Props = {
  title: string;
  description: string;
};

const RuleEmptyState = ({ title, description }: Props) => (
  <Wrapper>
    <Typography
      sx={{ fontWeight: fontWeight('semibold'), lineHeight: 'normal' }}
    >
      {title}
    </Typography>
    <Typography sx={{ fontSize: fontSize('base'), lineHeight: 'normal' }}>
      {description}
    </Typography>
  </Wrapper>
);

export default RuleEmptyState;
